<script>
import VulnerabilityReportTabs from '../shared/vulnerability_report/vulnerability_report_tabs.vue';
import ReportNotConfiguredInstance from './report_not_configured_instance.vue';

export default {
  components: {
    ReportNotConfiguredInstance,
    VulnerabilityReportTabs,
  },
  inject: ['hasProjects'],
};
</script>

<template>
  <report-not-configured-instance v-if="!hasProjects" />
  <vulnerability-report-tabs v-else />
</template>
